import React, { type ComponentPropsWithoutRef, forwardRef } from 'react';

import { StyledWrapper } from './styles';
import type { GridWrapperProps } from './types';

export type { ColumnGapType, GridWrapperProps, RowGapType } from './types';

type DivProps = Omit<ComponentPropsWithoutRef<'div'>, keyof GridWrapperProps>;

type Props = DivProps & GridWrapperProps;

export const GridWrapper = forwardRef<HTMLDivElement, Props>(
  ({ children, rowGap = 'm', columnGap = 'm', alignItems, justifyContent, ...props }, ref) => (
    <div {...props} ref={ref}>
      <StyledWrapper rowGap={rowGap} columnGap={columnGap} alignItems={alignItems} justifyContent={justifyContent}>
        {children}
      </StyledWrapper>
    </div>
  ),
);

GridWrapper.displayName = 'Grid.Wrapper';
